/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const CancelPolicyRoutes: Routes = [
  {
    path: RoutePaths.MODIFY_POLICY.CANCEL.REASONS.route,
    loadChildren: () => import('@pages/cancel-policy/reasons/reasons.module').then(m => m.ReasonsPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.CANCEL.CONDITIONS.route,
    loadChildren: () => import('@pages/cancel-policy/conditions/conditions.module').then(m => m.ConditionsPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MODIFY_POLICY.CANCEL.SUMMARY.route,
    loadChildren: () =>
      import('@pages/cancel-policy/summary/summary.module').then(m => m.CancelPolicySummaryPageModule),
    canActivate: [NavigationGuard],
  },
];
